import { render, staticRenderFns } from "./comment-player.vue?vue&type=template&id=44d29660&scoped=true&"
import script from "./comment-player.vue?vue&type=script&lang=js&"
export * from "./comment-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d29660",
  null
  
)

export default component.exports